import { PAIPAN } from '../core/paipan';

var COMMENT_DATA_MANAGER = {
    /**
     * 根据批盘的大运列表和服务器返回的大运流年批盘列表获取前端显示的列表数据
     * @param {大运前列表} beforeList 
     * @param {大运列表} fortuneList 
     * @param {类型列表} typeList
     * @param {大运流年批盘列表} bigData 
     */
    getDayunLiunianListByList(beforeList, fortuneList, typeList, bigData) {
        var resultData = [];
        var newFortuneList = [].concat(fortuneList);
        newFortuneList.forEach((data, index) => {
            var key = newFortuneList.length == 10 ? 'big'+(index+1) : 'big'+index, 
                dayunData = bigData[key], 
                typeList1 = dayunData.info.type && dayunData.info.type != '' ? JSON.parse(dayunData.info.type) : [],
                typeList2 = dayunData.info.type2 && dayunData.info.type2 != '' ? JSON.parse(dayunData.info.type2) : [];
            var liunianResult = [];
            if(newFortuneList.length == 10) {
                liunianResult = this.getLiunianListByList(data, typeList, dayunData);
            }else {
                liunianResult = index == 0 ? this.getBeforeLiunianList(beforeList, typeList, dayunData) : this.getLiunianListByList(data, typeList, dayunData);
            }
            var dayunEdited = dayunData.info.content != '' || typeList1.length != 0 || typeList2.length != 0 || liunianResult.edited;
            var newData = {
                year: data.year,
                name: data.type + data.year,
                typeBefore: data.typeBefore,
                ganzhi: data.ganzhi,
                key: key,
                content: dayunData.info.content,
                type: typeList.length > 0 ? this.getTypeListByList(typeList, typeList1) : typeList1,
                typeChoosed: typeList1.length,
                type2: typeList.length > 0 ? this.getTypeListByList(typeList, typeList2) : typeList2,
                type2Choosed: typeList2.length,
                edited: dayunEdited,
                liunian: liunianResult.result
            };
            // 修改大运列表数据的批盘编辑状态
            data.commentEdited = dayunEdited;
            resultData.push(newData);
        })
        console.error('getDayunLiunianListByList------', fortuneList, resultData)
        return resultData;
    },

    /**
     * 根据大运流年列表里的编辑状态来获取展开的activeNames
     * @param {大运流年列表} dayunliunianList 
     */
    getDayunLiunianListActiveNames(dayunliunianList){
        var dayunActiveNames = [], liunianActiveNames = [];
        _(dayunliunianList).forEach(function (dayunData) {
            if(dayunData.edited) {
                dayunActiveNames.push(dayunData.name);
            }
            _(dayunData.liunian).forEach(function (liunianData) {
                if(liunianData.edited) {
                    liunianActiveNames.push(liunianData.name);
                }
            })
        });
        return {
            dayun: dayunActiveNames,
            liunian: liunianActiveNames
        }
    },

    /**
     * 根据大运前几年数据及大运流年数据获取大运前几年流年列表数据
     * @param {大运前几年数据} beforeList 
     * @param {类型列表} typeList
     * @param {大运流年数据} dayunData 
     */
    getBeforeLiunianList(beforeList, typeList, dayunData) {
        var resultList = [], dayunEdited = false;
        beforeList.forEach((data, index) => {
            var key = 'y'+(index+1),
                liunianData = dayunData[key],
                typeList1 = liunianData.type && liunianData.type != '' ? JSON.parse(liunianData.type) : [],
                typeList2 = liunianData.type2 && liunianData.type2 != '' ? JSON.parse(liunianData.type2) : [];
            // 已编辑状态保存
            var liunianEdit = liunianData.content != '' || typeList1.length != 0 || typeList2.length != 0;
                dayunEdited = dayunEdited || liunianEdit;
            var age = data.title[0];
                age = age.split('\/');
                age = parseInt(age[1]);
            // 流年数据
            var newData = {
                year: data.year,
                name: 'liunian' + data.year,
                ganzhi: data.ganzhi,
                age: age,
                key: key,
                content: liunianData.content,
                type: typeList.length > 0 ? this.getTypeListByList(typeList, typeList1) : typeList1,
                typeChoosed: typeList1.length,
                type2: typeList.length > 0 ? this.getTypeListByList(typeList, typeList2) : typeList2,
                type2Choosed: typeList2.length,
                edited: liunianEdit
            };
            resultList.push(newData);
        });
        return {
            result: resultList,
            edited: dayunEdited
        }
    },

    /**
     * 根据大运开始年份及大运流年数据获取大运流年列表数据
     * @param {开始年份} startData 
     * @param {类型列表} typeList
     * @param {大运流年数据} dayunData 
     */
    getLiunianListByList(startData, typeList, dayunData) {
        var resultData = [], dayunEdited = false;
        var liunianList = PAIPAN.getLiuNian(startData.year),
            startAge = startData.title[0];
            startAge = startAge.split('\/');
            startAge = parseInt(startAge[1]);
        liunianList.forEach((data, index) => {
            var key = 'y' + (index + 1), 
                liunianData = dayunData[key], 
                typeList1 = liunianData.type && liunianData.type != '' ? JSON.parse(liunianData.type) : [],
                typeList2 = liunianData.type2 && liunianData.type2 != '' ? JSON.parse(liunianData.type2) : [];
            // 已编辑状态保存
            var liunianEdit = liunianData.content != '' || typeList1.length != 0 || typeList2.length != 0;
            dayunEdited = dayunEdited || liunianEdit;
            // 流年数据
            var newData = {
                year: data.y,
                name: 'liunian' + data.y,
                ganzhi: data.g_str + data.z_str,
                age: startAge + index,
                key: key,
                content: liunianData.content,
                type: typeList.length > 0 ? this.getTypeListByList(typeList, typeList1) : typeList1,
                typeChoosed: typeList1.length,
                type2: typeList.length > 0 ? this.getTypeListByList(typeList, typeList2) : typeList2,
                type2Choosed: typeList2.length,
                edited: liunianEdit
            };
            resultData.push(newData);
            // if(liunianEdit){
            //     console.log('getLiunianListByList------', data.y, liunianEdit, newData)
            // }
        })
        // console.log('getLiunianListByList-------', resultData, dayunEdited)
        return {
            result: resultData,
            edited: dayunEdited
        };
    },

    /**
     * 根据基础类型列表及服务器返回的type值获取前端typeList数据
     * @param {基础的类型列表} typeList 
     * @param {已选择类型列表} type
     */
    getTypeListByList(typeList, type) {
        var resultData = [];
        typeList.forEach((text, index) => {
            var newData = {
                index: index,
                text: text,
                choosed: type.indexOf(text) != -1
            }
            resultData.push(newData);
        });
        return resultData;
    },
    
    /**
     * 获取当前大运年份下流年列表的被编辑状态
     * @param {运盘的流年列表数据} origiList 
     * @param {大运流年列表数据} dayunList 
     * @param {当前大运起始年份} yearNum 
     */
    getMiniPanLiunianListByList(origiList, dayunList, yearNum) {
        // console.error('getMiniPanLiunianListByList-------', origiList, dayunList, yearNum)
        var dayunData = dayunList.filter(data => {return data.year == yearNum})[0],
            liunianList = dayunData ? dayunData.liunian : [];
        origiList.forEach((origiData, index) => {
            origiData.commentEdited = liunianList[index] ? liunianList[index].edited : false;
        });
        return origiList;
    },

    /**
     * 更新迷你命盘运盘中大运列表的被编辑状态
     * @param {运盘的大运列表数据} origiList 
     * @param {大运流年列表数据} dayunList 
     */
    updateMiniPanDayunListEdited(origiList, dayunList) {
        origiList.forEach((data, index) => {
            data.commentEdited = dayunList[index] ? dayunList[index].edited : false;
        });
        return origiList;
    },

    /**
     * 更新迷你命盘运盘中流年列表的被编辑状态
     * @param {运盘的流年列表数据} origiList 
     * @param {大运流年列表数据} dayunList 
     * @param {当前操作的流年数据} liunianData 
     */
    updateMiniPanLiunianListEdited(origiList, dayunList, liunianData) {
        console.log('updateMiniPanLiunianListEdited------', origiList, dayunList, liunianData)
        var dayunData = dayunList.filter(data => {return data.year == liunianData.dayun})[0],
            liunianList = dayunData ? dayunData.liunian : [];
        origiList.forEach((origiData, index) => {
            origiData.commentEdited = liunianList[index].edited;
        })
        return origiList;
    },
    
    /**
     * 根据评论数据更新大运流年列表的评论状态
     * @param {运盘的流年列表数据} origiList 
     * @param {大运列表数据} dayunList 
     * @param {评论数据} commentData 
     */
    updateMiniPanDayunCommented(origiList, dayunList, commentData) {
        origiList.forEach((element, x) => {
            var liunianList = dayunList[x] ? dayunList[x].liunian : [];
            if(liunianList.length > 0) {
                liunianList.forEach((liunianEl, y) => {
                    var key = 'big_' + dayunList[x].key + '_' + dayunList[x]['liunian'][y].key;
                    element.commented = element.commented || commentData[key] ? true : false;
                })
            }
        })
        return origiList;
    },

    /**
     * 根据评论数据更新大运流年列表的评论状态
     * @param {运盘的流年列表数据} origiList 
     * @param {流年列表数据} liunianList 
     * @param {评论数据} commentData 
     */
    updateMiniPanLiunianCommented(origiList, liunianList, commentData) {
        var startK = 'big_', curList = [];
        liunianList.forEach(element => {
            if(element.year == origiList[0].year) {
                startK = startK + element.key;
                curList = element.liunian;
            }
        });    
        origiList.forEach((data, index) => {
            var key = curList[index] ? (startK + '_' + curList[index].key) : undefined;
            data.commented = data.commented || (key && commentData[key]) ? true : false;
        });
        return origiList;
    },

    /**
     * 获取前端展示的药列表数据
     * @param {服务器返回的药数据} medicineList 
     */
    getMedicineListByList(medicineList) {
        var resultData = [];
        medicineList.forEach((data, index) => {
            var newData = {
                id: data.id,
                index: index,
                text: data.f_name ? data.f_name : (data.text ? data.text : ''),
                content: data.content ? data.content : '',
                withSub: index != 0 ? true : false,
                withPlus: index == medicineList.length - 1 && index < 7 ? true : false
            }
            resultData.push(newData);
        });
        return resultData;
    },

    /**
     * 根据基础类型数据获取本地客户端服务器用药数据
     * @param {基础类型数据} baseList 
     */
    getBaseMedicineListByList(baseList) {
        var resultData = [];
        baseList.forEach(data => {
            var newData = {
                id: data.id,
                f_name: data.text,
                content: ''
            }
            resultData.push(newData);
        })
        return resultData;
    },
    
    /**
     * 更新用药数据:用药类型
     * @param {服务器用药数据} medicine 
     * @param {当前改变的用药数据} curMedicineItem 
     * @param {改变后的用药数据} newMedicineItem 
     */
    updateMedicineListByData(medicine, curMedicineItem, newMedicineItem) {
        // console.log('updateMedicineListByData-----', medicine, curMedicineItem, newMedicineItem)
        medicine.forEach((data, index) => {
            // 找到修改的元素:根据index来找，不能根据id来找
            if(index == curMedicineItem.index) {
                // 更新服务器用药数据
                data.id = newMedicineItem.id;
                data.f_name = newMedicineItem.text;
            }
        });
        return medicine;
    },

    /**
     * 更新用药数据:用药内容
     * @param {服务器用药数据} medicine 
     * @param {当前改变的用药数据} curMedicineItem 
     * @param {输入的内容} content 
     */
    updateMedicineListContent(medicine, curMedicineItem, content) {
        medicine.forEach((data, index) => {
            if(index == curMedicineItem.index) {
                data.content = content;
            }
        });
        // console.log('updateMedicineListContent-----', medicine, curMedicineItem, content)
        return medicine;
    },
    
    /**
     * 新增用药数据:用药类型内容一整条
     * @param {服务器用药数据} medicine 
     * @param {新增用药数据} addData 
     */
    addMedicineListData(medicine, addData) {
        var resultData = [].concat(medicine);
        medicine.forEach((data, index) => {
            if(index == addData.index) {
                resultData.push({
                    id: data.id,
                    f_name: data.f_name,
                    content: ''
                });
            }
        })
        return resultData;
    },
    
    /**
     * 删除用药数据:用药类型内容一整条
     * @param {服务器用药数据} medicine 
     * @param {删除用药数据} deleteData 
     */
    deleteMedicineListData(medicine, deleteData) {
        var resultData = [].concat(medicine);
        medicine.forEach((data, index) => {
            if(index == deleteData.index) {
                resultData.splice(index, 1);
            }
        })
        return resultData;
    },

    /**
     * 获取大运流年数据修改的参数:上传到服务器
     * 同时更新了客户端大运流年数据+服务器大运流年数据
     * @param {客户端大运流年列表数据} dayunliunianList
     * @param {服务器大运流年数据} bigData 
     * @param {修改参数} params 
     */
    getBigParamsByParams(dayunliunianList, bigData, params) {
        var changeType = params.type, infoKey = 'big_', infoValue = '', 
            dayunYear = params.parentData.dayun ? params.parentData.dayun : 0,
            liunianYear = params.parentData.liunian ? params.parentData.liunian : 0;
            // console.log('getBigParamsByParams------', dayunliunianList, bigData, params, changeType);

        dayunliunianList.forEach((dayunData) => {
            if(dayunData.year == dayunYear) {
                infoKey += dayunData.key
                // console.log('dayuuuuuuuuuuun-----', dayunData, dayunData.edited, dayunData[params.key])
                // 处理新的值:info_type info_type2
                if(changeType == 'dayun'){
                    if(params.key == 'type' || params.key == 'type2') {
                        var typeStr = bigData[dayunData.key]['info'][params.key],
                            typeList = typeStr != '' ? JSON.parse(typeStr) : [],
                            typeText = params.itemData.text,
                            typeIndex = typeList.indexOf(typeText);
                        // 选中状态
                        if(params.choosed && typeIndex == -1){
                            typeList.push(typeText)
                        }
                        // 非选中状态
                        if(!params.choosed && typeIndex != -1){
                            typeList.splice(typeIndex, 1)
                        }

                        infoKey = infoKey + '_info_' + params.key;
                        infoValue = JSON.stringify(typeList);
                        bigData[dayunData.key]['info'][params.key] = JSON.stringify(typeList);
                        // console.log('dayun--------type------', typeText, typeIndex, typeList, params.choosed)
                        
                        // 更新编辑状态
                        dayunData[params.key] = this.updateTypeListData(dayunData[params.key], typeList);
                        dayunData[params.key+'Choosed'] = typeList.length;
                        dayunData.edited = this.updateDayunEdited(bigData[dayunData.key]);

                        console.log('dayun---------更新编辑状态::::::', dayunData[params.key], dayunData.edited)
                    }else if (params.key == 'content') {
                        // 修改内容
                        infoKey = infoKey + '_info_' + params.key;
                        infoValue = params.text;
                        bigData[dayunData.key]['info'][params.key] = params.text;

                        // 更新编辑状态
                        dayunData[params.key] = params.text;
                        dayunData.edited = this.updateDayunEdited(bigData[dayunData.key]);
                        console.log('dayun---------content----', infoKey, infoValue, dayunData[params.key], dayunData.edited)
                    }
                }else if(changeType == 'liunian') {
                    // 如果是流年，继续遍历流年
                    dayunData.liunian.forEach(liunianData => {
                        if(liunianData.year == liunianYear) {
                            infoKey = infoKey + '_' + liunianData.key;
                            // console.log('liuniannnnnnnnnnnnnnnnn-----', liunianData, liunianData.edited)
                            if(params.key == 'type' || params.key == 'type2') {
                                var lnTypeStr = bigData[dayunData.key][liunianData.key][params.key],
                                    lnTypeList = lnTypeStr != '' ? JSON.parse(lnTypeStr) : [],
                                    lnTypeText = params.itemData.text,
                                    lnTypeIndex = lnTypeList.indexOf(lnTypeText);
                                // 选中状态
                                if(params.choosed && lnTypeIndex == -1){
                                    lnTypeList.push(lnTypeText)
                                }
                                // 非选中状态
                                if(!params.choosed && lnTypeIndex != -1){
                                    lnTypeList.splice(lnTypeIndex, 1)
                                }
                                infoKey = infoKey + '_' + params.key;
                                infoValue = JSON.stringify(lnTypeList);
                                bigData[dayunData.key][liunianData.key][params.key] = JSON.stringify(lnTypeList);

                                // 更新编辑状态
                                liunianData[params.key] = this.updateTypeListData(liunianData[params.key], lnTypeList);
                                liunianData[params.key+'Choosed'] = lnTypeList.length;

                                // 同步更新大运流年的编辑状态
                                dayunData.edited = this.updateDayunEdited(bigData[dayunData.key]);
                                liunianData.edited = this.updateLiunianEdited(bigData[dayunData.key][liunianData.key]);
                                console.log('liunian---------type--------', lnTypeText, lnTypeIndex, lnTypeList, params.choosed)
                            }else if (params.key == 'content') {
                                // 修改内容
                                infoKey = infoKey + '_' + params.key;
                                infoValue = params.text;
                                bigData[dayunData.key][liunianData.key][params.key] = params.text;

                                // 更新编辑状态
                                liunianData[params.key] = params.text;
                                dayunData.edited = this.updateDayunEdited(bigData[dayunData.key]);
                                liunianData.edited = this.updateLiunianEdited(bigData[dayunData.key][liunianData.key]);
                                console.log('liunian---------content-----', infoKey, infoValue, liunianData[params.key], liunianData.edited)
                            }
                        }
                    })
                }
            }
        })
        var infoData = {}; infoData[infoKey] = infoValue;
        console.log('infooooooooooo-----', infoKey, infoValue, infoData, bigData, dayunliunianList);
        return {
            infoData: JSON.stringify(infoData)
        }
    },

    /**
     * 更新前端类型列表数据choosed值
     * @param {前端类型列表数据} typeListData 
     * @param {本地更新的服务端类型数据} typeList 
     */
    updateTypeListData(typeListData, typeList) {
        typeListData.forEach(data => {
            data.choosed = typeList.indexOf(data.text) != -1 ? true : false;
        })
        // console.log('updateTypeListData------', typeListData, typeList)
        return typeListData;
    },

    /**
     * 更新前端大运数据的编辑状态
     * @param {大运数据} bigData 
     */
    updateDayunEdited(bigData){
        var result = false;
        for(var key in bigData) {
            var hasContent = bigData[key].content != '' ? true : false,
                typeList1 = bigData[key].type && bigData[key].type != '' ? JSON.parse(bigData[key].type) : [],
                hasType = typeList1.length != 0 ? true : false,
                typeList2 = bigData[key].type2 && bigData[key].type2 != '' ? JSON.parse(bigData[key].type2) : [],
                hasType2 = typeList2.length != 0 ? true : false;
            result = hasContent || hasType || hasType2;
            console.log('updateDayunEdited------', hasContent, hasType, hasType2, result);
            if(result) {
                return result;
            }
        }
        return result;
    },

    /**
     * 更新前端流年数据的编辑状态
     * @param {流年数据} liunianData 
     */
    updateLiunianEdited(liunianData){
        var result = false,
            hasContent = liunianData.content != '' ? true : false,
            typeList1 = liunianData.type && liunianData.type != '' ? JSON.parse(liunianData.type) : [],
            hasType = typeList1.length != 0 ? true : false,
            typeList2 = liunianData.type2 && liunianData.type2 != '' ? JSON.parse(liunianData.type2) : [],
            hasType2 = typeList2.length != 0 ? true : false;
        result = hasContent || hasType || hasType2;
        console.log('updateLiunianEdited------', hasContent, hasType, hasType2, result);
        return result;
    },
}

export {
    COMMENT_DATA_MANAGER
}